import { render, staticRenderFns } from "./AspectPageSingle.vue?vue&type=template&id=62c3888c&scoped=true&"
import script from "./AspectPageSingle.vue?vue&type=script&lang=js&"
export * from "./AspectPageSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c3888c",
  null
  
)

export default component.exports